import React, { useState, useEffect } from "react";
import { QuickStart } from "../quickstart/quickstart-ctrl";
import { DigitalPlanView } from "./digital-plan-view";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
import "./digital-plan.scss";
export const DigitalPlanController = (props) => {
	const [onTab, setOnTab] = useState(0);
	const hashvalue = window.location.hash;
	useEffect(() => {
		if (hashvalue == "#startup") {
			setOnTab(1);
		}
		if (hashvalue == "#transforming") {
			setOnTab(2);
		}
		if (hashvalue == "#accelerating") {
			setOnTab(3);
		}
		if (hashvalue == "#thriving") {
			setOnTab(4);
		}
		props.handleExpandFal();
	}, []);

	return (
		<>
			<Helmet>
				<title>Digital Plant Archetypes | SmarterChains</title>
				<meta name="description" content="Digital Plant Archetypes" />
			</Helmet>
			<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
			<BreadcrumbsItem to="/learning-center">Resource Center</BreadcrumbsItem>
			<BreadcrumbsItem to="/digital-plant">Digital Plant Archetypes</BreadcrumbsItem>
			<DigitalPlanView onTab={onTab} setOnTab={setOnTab} {...props} />
			
		</>
	);
};
